/*
 *
 * Surveys constants
 *
 */

export const CREATE_SURVEY_WATCHER = "app/Surveys/CREATE_SURVEY_WATCHER"
export const CREATE_SURVEY_SUCCESS = "app/Surveys/CREATE_SURVEY_SUCCESS"
export const CREATE_SURVEY_FAILED = "app/Surveys/CREATE_SURVEY_FAIED"

export const DELETE_SURVEY_WATCHER = "app/Surveys/DELETE_SURVEY_WATCHER"
export const DELETE_SURVEY_SUCCESS = "app/Surveys/DELETE_SURVEY_SUCCESS"
export const DELETE_SURVEY_FAILED = "app/Surveys/DELETE_SURVEY_FAILED"

export const GET_SURVEYS = "app/Surveys/GET_SURVEYS"
export const GET_SURVEYS_SUCCESS = "app/Surveys/GET_SURVEYS_SUCCESS"
export const GET_SURVEYS_FAILED = "app/Surveys/GET_SURVEYS_FAILED"

export const GET_SURVEY_WATCHER = "app/Surveys/GET_SURVEY_WATCHER"
export const GET_SURVEY_SUCCESS = "app/Surveys/GET_SURVEY_SUCCESS"
export const GET_SURVEY_FAILED = "app/Surveys/GET_SURVEY_FAILED"

export const GET_SURVEYS_TEMPLATE_WATCHER =
  "app/Surveys/GET_SURVEYS_TEMPLATE_WATCHER"
export const GET_SURVEYS_TEMPLATE_SUCCESS =
  "app/Surveys/GET_SURVEYS_TEMPLATE_SUCCESS"
export const GET_SURVEYS_TEMPLATE_FAILED =
  "app/Surveys/GET_SURVEYS_TEMPLATE_FAILED"

export const DUPLICATE_SURVEY_WATCHER = "app/Surveys/DUPLICATE_SURVEY_WATCHER"
export const DUPLICATE_SURVEY_SUCCESS = "app/Surveys/DUPLICATE_SURVEY_SUCCESS"
export const DUPLICATE_SURVEY_FAILED = "app/Surveys/DUPLICATE_SURVEY_FAILED"

export const GET_SURVEY_ENPS_WATCHER = "app/Surveys/GET_SURVEY_ENPS_WATCHER"
export const GET_SURVEY_ENPS_SUCCESS = "app/Surveys/GET_SURVEY_ENPS_SUCCESS"
export const GET_SURVEY_ENPS_FAILED = "app/Surveys/GET_SURVEY_ENPS_FAILED"

export const GET_SURVEY_QUALITATIVE_WATCHER =
  "app/Surveys/GET_SURVEY_QUALITATIVE_WATCHER"
export const GET_SURVEY_QUALITATIVE_SUCCESS =
  "app/Surveys/GET_SURVEY_QUALITATIVE_SUCCESS"
export const GET_SURVEY_QUALITATIVE_FAILED =
  "app/Surveys/GET_SURVEY_QUALITATIVE_FAILED"

export const DOWNLOAD_SURVEYS_WATCHER = "app/Surveys/DOWNLOAD_SURVEY_WATCHER"
export const DOWNLOAD_SURVEYS_SUCCESS = "app/Surveys/DOWNLOAD_SURVEY_SUCCESS"
export const DOWNLOAD_SURVEYS_FAILED = "app/Surveys/DOWNLOAD_SURVEY_FAILED"

export const GET_SEGMENTS_WATCHER = "app/Surveys/GET_SEGMENTS_WATCHER"
export const GET_SEGMENTS_SUCCESS = "app/Surveys/GET_SEGMENTS_SUCCESS"
export const GET_SEGMENTS_FAILED = "app/Surveys/GET_SEGMENTS_FAILED"

export const GET_SURVEY_TYPES_WATCHER = "app/Surveys/GET_SURVEY_TYPES_WATCHER"
export const GET_SURVEY_TYPES_SUCCESS = "app/Surveys/GET_SURVEY_TYPES_SUCCESS"
export const GET_SURVEY_TYPES_FAILED = "app/Surveys/GET_SURVEY_TYPES_FAILED"

export const GET_SCOPE_TYPES_WATCHER = "app/Surveys/GET_SCOPE_TYPES_WATCHER"
export const GET_SCOPE_TYPES_SUCCESS = "app/Surveys/GET_SCOPE_TYPES_SUCCESS"
export const GET_SCOPE_TYPES_FAILED = "app/Surveys/GET_SCOPE_TYPES_FAILED"

export const GET_SURVEYS_BY_INDICATORS_WATCHER =
  "app/Surveys/GET_SURVEYS_BY_INDICATORS_WATCHER"
export const GET_SURVEYS_BY_INDICATORS_SUCCESS =
  "app/Surveys/GET_SURVEYS_BY_INDICATORS_SUCCESS"
export const GET_SURVEYS_BY_INDICATORS_FAILED =
  "app/Surveys/GET_SURVEYS_BY_INDICATORS_FAILED"
